import store from '../index'

const state = {
  toasterOpen: false,
  toasterMessage: '',
  toasterStatus: '',
}

const getters = {
  isToasterOpen: (state) => state.toasterOpen,
  toasterMessage: (state) => state.toasterMessage,
  toasterStatus: (state) => state.toasterStatus,
}

const actions = {
  showSuccessMessage({ commit }, message) {
    commit('setIsToasterOpen', true)
    commit('setToasterMessage', message)
    commit('setToasterStatus', 'green')
  },

  showErrorMessage({ commit }, message) {
    commit('setIsToasterOpen', true)
    commit('setToasterMessage', message)
    commit('setToasterStatus', 'red')
  },
}

const mutations = {
  setIsToasterOpen: (state, status) => {
    state.toasterOpen = status
  },

  setToasterMessage: (state, status) => {
    state.toasterMessage = status

    if (state.toasterOpen) {
      setTimeout(() => {
        store.commit('setIsToasterOpen', false)
        store.commit('setToasterMessage', '')
      }, 6000)
    }
  },

  setToasterStatus: (state, status) => {
    state.toasterStatus = status
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
